import Vue from 'vue';

const success = (context, response) => {
  toastr.success(response.msg);
  context.smallLoading = false;
  context.closeModal('#create-task-modal');
};

const failed = (context, error) => {
  context.showToasterError(error);
  context.smallLoading = false;
};

export default (context, data) => {
  return Vue.$http.post('tasks', data)
    .then(response => {
      success(context, response.data)
    }).catch(error => {
      failed(context, error)
    })
}



// WEBPACK FOOTER //
// ./src/app/services/task/store.js